import { Eyebrow } from "./SectionHeading";
import { requestContactInterest } from "./contactInterest";

const tracks = [
  { label: "Co-build", text: "Shape a new tool around a problem your team has today." },
  { label: "Pilot", text: "Run our products early on real work and tell us what breaks." },
];

const PartnerSection = () => (
  <section
    id="partner"
    className="mx-auto max-w-[1200px] scroll-mt-[68px] px-[clamp(16px,5vw,48px)] py-[clamp(80px,10vw,140px)]"
  >
    <div className="flex flex-wrap items-start gap-x-16 gap-y-10 border-y border-border py-[clamp(40px,6vw,72px)]">
      <div className="flex-[1_1_300px]">
        <Eyebrow index="04" label="Partnerships" />
        <h2 className="mt-[18px] text-[clamp(32px,4.4vw,56px)] font-semibold leading-[1.05] tracking-[-0.035em]">
          Partner with us
        </h2>
      </div>
      <div className="min-w-0 flex-[1.4_1_420px]">
        <p className="text-pretty text-[clamp(18px,1.8vw,22px)] leading-[1.5] tracking-[-0.01em]">
          We work with a small number of companies to co-build and pilot new tools for AI-assisted development. If your
          team is figuring out how people and agents work together, we'd like to compare notes.
        </p>
        <div className="mt-8 grid grid-cols-[repeat(auto-fit,minmax(min(100%,220px),1fr))] gap-6">
          {tracks.map((t) => (
            <div key={t.label}>
              <div className="font-mono text-xs uppercase tracking-[0.06em] text-muted-foreground">{t.label}</div>
              <p className="mt-2 text-[15px] leading-[1.6] text-muted-foreground">{t.text}</p>
            </div>
          ))}
        </div>
        <a
          href="#contact"
          onClick={() => requestContactInterest("Partnership")}
          className="mt-9 inline-flex min-h-[50px] items-center gap-2.5 rounded-xl border border-border bg-card px-[22px] text-[15px] font-medium text-foreground hover:border-accent hover:text-foreground"
        >
          Start a conversation
          <span aria-hidden="true">→</span>
        </a>
      </div>
    </div>
  </section>
);

export default PartnerSection;
